module.exports = __webpack_public_path__ + "img/marker_grey.8241f360.svg";